import { useMemo, useState, type ReactNode } from "react";
import { Button, Drawer, SectionTitle } from "@/ui";
import { ExportTasks } from "./ExportTasks";
import { exportOpen, useMessageExports } from "./exports";
import { TaskCenterCtx, useTaskCenter } from "./taskCenterContext";
import { ToolIcon } from "./toolIcons";

/** 任务中心（决策 D205）：包住整个应用外壳，打开时在右侧抽屉里统一管理后台任务。目前只有消息导出（D202），
 * 以后的后台任务在抽屉里按种类各占一节。顶栏用 TaskCenterButton 打开，页面建了任务后用 useTaskCenter 打开。 */
export function TaskCenterProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const api = useMemo(() => ({ open: () => setOpen(true) }), []);
  return (
    <TaskCenterCtx.Provider value={api}>
      {children}
      {open && (
        <Drawer open title="任务中心" onClose={() => setOpen(false)} footer={<Button onClick={() => setOpen(false)}>关闭</Button>}>
          <section className="ax-section" aria-label="消息导出">
            <SectionTitle>消息导出</SectionTitle>
            <ExportTasks />
          </section>
        </Drawer>
      )}
    </TaskCenterCtx.Provider>
  );
}

/** 顶栏的任务中心按钮：只有图标的次要按钮，外框、底色与圆角同旁边的主题切换；名称在悬停提示与无障碍名称里，
 * 有进行中的任务时右上角显示个数（按 2 秒刷新，useMessageExports）。 */
export function TaskCenterButton() {
  const { open } = useTaskCenter();
  const running = useMessageExports().data?.filter(exportOpen).length ?? 0;
  const label = running ? `任务中心，${running} 个进行中` : "任务中心";
  return (
    <Button size="sm" iconOnly badge={running} onClick={open} aria-label={label} title={label}>
      <ToolIcon name="tasks" />
    </Button>
  );
}
